import { Loading } from "@/components/overlays/Loading";
import supabase from "@/features/supabase";
import { useGetCurrentUserQuery } from "@/store/services/supabase";
import { currentPathWithQuery, loginHref } from "@/utils/url";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
export const PasswordNeedsChangeCheck = ({
  children
}: {
  children: JSX.Element;
}) => {
  const router = useRouter();
  const {
    data: user,
    isError,
    isFetching,
    refetch
  } = useGetCurrentUserQuery();
  const hasRetried = useRef(false);
  useEffect(() => {
    if (user && user.needs_password_reset) {
      router.push("/change-password");
    }
  }, [user]);
  useEffect(() => {
    if (!isError || isFetching) return;
    if (!hasRetried.current) {
      hasRetried.current = true;
      refetch();
      return;
    }
    const restartSignIn = async () => {
      await supabase.auth.signOut({
        scope: "local"
      });
      router.replace(loginHref(currentPathWithQuery()));
    };
    restartSignIn();
  }, [isError, isFetching]);
  if (!user) {
    return <Loading />;
  }
  return children;
};